import { Actions, ButtonLink, IconArrow, Tiles } from 'braid-design-system';

import { PageIcon } from '#src/components/PageIcon/PageIcon.tsx';
import { TileLink } from '#src/components/TileLink/TileLink.tsx';

export const CurrentGuides = () => (
  <Tiles columns={[1, 1, 2]} space="small">
    <TileLink
      description="Latest revision of Apply with SEEK, Ad Performance, and application tracking"
      href="/guides/2025-revision"
      icon={<PageIcon icon="Guide" />}
      title="2025 Apply with SEEK revision"
    />

    <TileLink
      description="Long-lived reference for monitoring the health of your SEEK API integration"
      href="/guides/monitoring"
      icon={<PageIcon icon="Monitoring" />}
      title="Monitoring and troubleshooting"
    />

    <TileLink
      description="Instructions about what to do if you discover a security incident"
      href="/guides/security-incident"
      icon={<PageIcon icon="Guide" />}
      title="Report a security incident"
    />
  </Tiles>
);

export const ArchivedGuides = () => (
  <Actions>
    <ButtonLink
      href="/migration-guides/archived"
      icon={<IconArrow direction="right" />}
      variant="soft"
    >
      Jump to archive
    </ButtonLink>
  </Actions>
);
